<!-- 百分比上传组件 -->

<template>
<div class="load-btn">
  <el-upload ref="upload"
    :action="upUrl" :headers="postHead"
    :class="isAct"
    :before-upload="prevCtrls"
    :on-success="successCtrls"
    :file-list="imgfiles"
    :disabled="ableSet"
    list-type="picture-card"
    :data="fileData"
    :on-remove="handleRemove"
    :limit="1"
    :on-preview="handlePictureCardPreview"
    :on-exceed="handleExceed">
    <i class="el-icon-plus"></i>
      <!-- <div>
        <div class="edName uploadLine"></div>
        <div class="icons" style="padding-left:5px;">
          <img src="../../../assets/images/left.png" @click="handleLeftRotate(dialogImageUrl)">
          <img src="../../../assets/images/right.png" @click="handleRightRotate(dialogImageUrl)">
        </div>
      </div> -->
  </el-upload>
  <el-dialog :visible.sync="dialogVisible" center style="margin:auto;">
    <img width="100%" :src="dialogImageUrl" alt="">
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleLeftRotate(dialogImageUrl)">
        <img src="../../../assets/images/left.png">
      </el-button>
      <el-button @click="handleRightRotate(dialogImageUrl)">        
        <img src="../../../assets/images/right.png">
      </el-button>
    </span>
  </el-dialog>

  
</div>
</template>

<script>
import {
  getToken
} from '@/utils/auth';

import {
  rotateImg,
  rotateImgBase64,
  dataURLtoFile
} from '@/components/ImgFilp/canvas-rotate-image';

import {
  uploadBase64
} from '@/api/file';

import {
  getFileToken
} from '@/api/account';
import { getPfileUrl } from '@/api/pressRole/pressRole';
export default {
  props: ['btnProps','ableSure',"limit","viewType"],
  data() {
    return {
      fileData: {},
      // dialogImageUrl: '',
      fileToken: '',
      upUrl:'',
      postHead:{},
      dialogVisible:false,
      dialogImageUrl: '',
      imgfiles:[],
      imgIds:[],
      imgmap:{},
      imgNum:1,

      ableSet:false,
      isAct:''
    }
  },
  watch: {
    imgIds:{
      handler(newValue, oldValue) {
        if(this.viewType==2 || (newValue && newValue.length>=1)){
          // this.ableSet = true;
          this.isAct = 'addHide';
        }
        else{
          console.log('重新设置了')
          this.ableSet = false;
          this.isAct = '';
        }
        // for (let i = 0; i < newValue.length; i++) {
        //   if (oldValue[i] != newValue[i]) {
        //     console.log(newValue)
        //   }
        // }
      },
      deep: true
    },
    ableSure: function(dat) {
      this.initAbleSure(dat);
    //     console.log("watch ableSure",dat);
    //     this.imgmap = {};
    //     this.imgfiles = [];
    //     this.imgIds = [];
    //     if(this.ableSure){

    //       if(!this.fileToken){
    //         getFileToken().then(response => {
    //             this.fileToken = response.resultStatus.token;
    //             var arr = this.ableSure.split(',');
    //             if(arr.length>0){
    //                 for(var index in arr){
    //                     this.imgInit(arr[index]);
    //                 }
    //             }
    //         })
    //       }else{
    //         var arr = this.ableSure.split(',');
    //         if(arr.length>0){
    //             for(var index in arr){
    //                 this.imgInit(arr[index]);
    //             }
    //         }
    //       }
    //     }
    }
  },
  methods: {    
    // 左转
    handleLeftRotate(dialogImageUrl) {
      console.log('测试')
      const that = this;
      if (dialogImageUrl.toString().startsWith("http")) {
        rotateImg(dialogImageUrl, -90, function (base64) {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      } else {
        rotateImgBase64(dialogImageUrl, -90, (base64) => {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      }
    },
    // 右转
    handleRightRotate(dialogImageUrl) {
      const that = this;
      if (dialogImageUrl.toString().startsWith("http")) {
        rotateImg(dialogImageUrl, 90, (base64) => {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      } else {
        rotateImgBase64(dialogImageUrl, 90, (base64) => {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      }

    },
    //手动提交图片
    submitUpload() {
      // this.$refs.upload.submit();
      // this.ableSure = "";
      let that = this;
      if (!this.dialogImageUrl.toString().startsWith("http")) {
        uploadBase64({ ableSure: this.ableSure ,base64:this.dialogImageUrl});
        // this.ableSure = this.props.ableSure;
        this.initAbleSure(this.ableSure);
        // that.$forceUpdate();
      }
    },
    initAbleSure: function(dat){
      console.log("watch ableSure",dat);
      this.imgmap = {};
      this.imgfiles = [];
      this.imgIds = [];
      if(this.ableSure){

        if(!this.fileToken){
          getFileToken().then(response => {
              this.fileToken = response.resultStatus.token;
              var arr = this.ableSure.split(',');
              if(arr.length>0){
                  for(var index in arr){
                      this.imgInit(arr[index]);
                  }
              }
          })
        }else{
          var arr = this.ableSure.split(',');
          if(arr.length>0){
              for(var index in arr){
                  this.imgInit(arr[index]);
              }
          }
        }
        // console.log(dat);

      }
    },
    prevCtrls: function(file) {
      let nameArr = file.type.split('/');
      let fileType = nameArr[nameArr.length - 1];

      if (fileType != 'jpeg' && fileType != 'png') {
        this.$message({
          message: '请上传格式为 JPGE 或 PNG 的文件！',
          type: 'error'
        })
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        })
        return false;
      } else {
        this.postHead['Authorization'] = `Bearer ${getToken()}`;
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        return true;

      }
    },
    successCtrls: function(data) {
      // console.log('我上传成功了,data=',JSON.stringify(data));
      // this.imgIds.push(data.payload.id);

      let dat = data.payload.id;

      // if(dat){
      //     this.ableSet = true;
      //     this.isAct = 'addHide';
      // }

      getPfileUrl({id: dat}).then(response => {
        let url = response.payload.url
        console.log('url=',url);
        var file = {
          id:dat,
          name: dat + '.jpeg',
          url: url+"?"+new Date().getTime()
        }
        this.imgmap[dat]=file;
        this.imgfiles= [file];
        this.imgIds=[dat];

        console.log('successCtrls=',JSON.stringify(this.imgIds));

        console.log('this.imgIds.join()=',this.imgIds.join());
        this.$emit('upFileId', this.imgIds.join(),this.btnProps);
      })

      
    },

    imgInit: function(dat) {
        if(dat){
            if(!this.imgmap[dat]){
                console.log('dat=',JSON.stringify(dat));
                var url;
                getPfileUrl({id: dat}).then(response => {
                  url = response.payload.url
                  console.log('url=',url);
                  // var url = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
                  var file = {
                    id:dat,
                    name: dat + '.jpeg',
                    url: (url+'?tamp=' + (new Date()).valueOf())
                  }
                  this.imgmap[dat]=file;
                  this.imgfiles.push(file);
                  this.imgIds.push(dat);
                })
                
            }
        }
        console.log("imgInit",this.imgfiles);

    },

    handleExceed: function(files, fileList) {
        // var num = 1;
        // if(this.limit){
        //     this.imgNum=this.limit;
        // }
        //
        // console.log(fileList,files,this.imgNum);
        //
        // if(fileList.length+files.length>this.imgNum){
        //     this.$message({
        //       message: "最多只能上传"+this.imgNum+"个文件!",
        //       type: 'error'
        //     });
        // }
        this.$message({
          message: "最多只能上传"+this.imgNum+"个文件!",
          type: 'error'
        });
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url+"?"+new Date().getTime();
        this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      for(var index in this.imgIds){
        console.log(file.id , ' ' ,this.imgIds[index]);
          if(this.imgIds[index] == file.id ){
            console.log('我是相同的，为啥删除不了呢？')
              this.imgIds.splice(index,1);
          }
      }

      console.log('this.imgIds=',JSON.stringify(this.imgIds));

      this.$emit('upFileId', this.imgIds.join(),this.btnProps);

    },
  },

  created: function() {
    // console.log('viewType=',this.viewType)
    // this.upUrl = process.env.BASE_API + '/File/File/upload';
    this.upUrl = process.env.BASE_API + '/eavar/file/upload';
    if(this.limit){
        this.imgNum = this.limit;
    }
    var arr = this.ableSure.split(',');
    console.log('arr=',JSON.stringify(arr))
    if(this.viewType == 2 || (this.ableSure && arr && arr.length!=0 && arr.length>=this.imgNum)){
        this.ableSet = true;
        this.isAct = 'addHide';
    }

    // console.log('this.ableSure=',this.ableSure.ableSure);
    // this.initAbleSure(this.ableSure);

    // console.log("created ableSure=",this.ableSure);
    // if(!this.fileToken){
    //     getFileToken().then(response => {
    //         this.fileToken = response.resultStatus.token;

    //         if(this.ableSure){

    //           this.initAbleSure(this.ableSure);

    //           // var arr = this.ableSure.split(',');
    //           // if(arr.length>0){
    //           //     for(var index in arr){
    //           //         this.imgInit(arr[index]);
    //           //     }
    //           // }
    //         }

    //     })
    // }


  }
}
</script>

<style scope>
.upload-btn {
  display: inline-block;
}

.progressBox {
  width: 480px;
  margin-top: 6px;
}

.imgBox {
  height: 120px;
  margin-bottom: 9px;
}

.imgBox img {
  height: 100%;
}

.addHide .el-upload--picture-card{
  display: none;
}

.addHide .el-upload-list .el-upload-list__item{
  margin: 0 8px 0 0;
}
</style>



// WEBPACK FOOTER //
// uploadSingle.vue?5fdf4c44